import Flex from '@Components/Bases/Flex';
import { ISummarizeReport } from '@Domains/Progress';
import { CheckCircle } from '@mui/icons-material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Button, Typography } from '@mui/material';
import { progressStepFromBoardDirectorData } from '../../utils';
import { useNavigate } from 'react-router-dom';

type StepFromBoardDirectorProps = {
  score: number;
  summarizeReport?: ISummarizeReport;
  reportId?: number;
};

const StepFromBoardDirector = ({
  score,
  summarizeReport,
  reportId,
}: StepFromBoardDirectorProps) => {
  const progressSteps = progressStepFromBoardDirectorData(
    score,
    summarizeReport
  );
  const navigate = useNavigate();

  const isPublished = Boolean(summarizeReport?.publishedDate);

  const handleEdit = (item: (typeof progressSteps)[number]) => {
    let queryParam = '';
    if (item.title === 'ตรวจสอบข้อมูล') {
      queryParam = '?review-data';
    } else if (item.title === 'บันทึกวันที่มีมติจากคณะกรรมการบริษัท') {
      queryParam = '?record-resolution-date';
    } else if (item.title === 'เผยแพร่รายงาน') {
      queryParam = '?publish-report';
    }

    navigate(`/report/${reportId}/review-summary-report${queryParam}`);
  };

  return (
    <Flex bgcolor={'white'} flexDirection="column" p={1}>
      <Typography variant="subtitle2">
        3. ขั้นตอนการบันทึกวันที่มีมติจากคณะกรรมการบริษัท
      </Typography>
      {progressSteps.map((item, index) => (
        <Flex p={1} key={index}>
          <Flex justifyContent="space-between" width={1}>
            <Flex p={1}>
              {item.progress === 0 ? (
                <AccessTimeFilledIcon
                  sx={(theme) => ({
                    color: theme.palette.secondary.lighter,
                    mr: 1,
                  })}
                />
              ) : (
                <CheckCircle
                  sx={(theme) => ({ color: theme.palette.success.main, mr: 1 })}
                />
              )}
              <Typography>{item.title}</Typography>
            </Flex>

            <Button
              variant="text"
              color="info"
              sx={{ fontWeight: 'regular' }}
              onClick={() => handleEdit(item)}
              disabled={item.disabled}
            >
              {isPublished ? 'ดูข้อมูล' : 'แก้ไขข้อมูล'}
            </Button>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default StepFromBoardDirector;
